import { Alert, Button, Card, Space, Typography } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { openChannelTalk } from '../../lib/channel-talk'
import { loginStyles } from '../login/loginStyles'

const { Title, Paragraph } = Typography

/** Shown when a social login succeeded but the account is not a BOLTB member or not a dealer. */
export function DealerAccess() {
  const { t } = useTranslation()
  const [opening, setOpening] = useState(false)
  const [unavailable, setUnavailable] = useState(false)

  const handleRequest = async () => {
    setOpening(true)
    const opened = await openChannelTalk()
    setOpening(false)
    setUnavailable(!opened)
  }

  return (
    <div style={loginStyles.container}>
      <Card style={loginStyles.card}>
        <div style={loginStyles.header}>
          <img src="/boltb-logo.png" alt="BoltB" style={loginStyles.logo} />
          <Title level={3} style={loginStyles.title}>
            {t('pages.dealerAccess.title')}
          </Title>
        </div>

        <Paragraph>{t('pages.dealerAccess.description')}</Paragraph>
        <Paragraph type="secondary">{t('pages.dealerAccess.howToRequest')}</Paragraph>

        {unavailable && (
          <Alert
            data-testid="dealer-access-channel-unavailable"
            type="warning"
            showIcon
            message={t('pages.dealerAccess.channelTalkUnavailable')}
            style={{ marginBottom: 16 }}
          />
        )}

        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Button
            data-testid="dealer-access-request-btn"
            type="primary"
            block
            size="large"
            loading={opening}
            onClick={() => void handleRequest()}
          >
            {t('pages.dealerAccess.requestButton')}
          </Button>
          <Link to="/login">
            <Button data-testid="dealer-access-login-btn" block>
              {t('pages.dealerAccess.loginButton')}
            </Button>
          </Link>
        </Space>
      </Card>
    </div>
  )
}
